module.exports = __webpack_public_path__ + "img/bluecare.9f75bab.png";